export default __webpack_public_path__ + "static/media/330_private01-fr-mobile.6dc18192.png";